const artiumCashReduction = {
    redemptionRules: [
        {
          count: 36,
          INRamount: 5000,
          USDamount: 125,
          CADamount: 125,
          AUDamount: 125,
          GBPamount: 125,
          SGDamount: 125,
          AEDamount: 437.5,
          EURamount: 125
        },
        {
          count: 24,
          INRamount: 2000,
          USDamount: 75,
          CADamount: 75,
          AUDamount: 75,
          GBPamount: 75,
          SGDamount: 75,
          AEDamount: 262.5,
          EURamount: 75
        },
        {
          count: 12,
          INRamount: 500,
          USDamount: 25,
          CADamount: 25,
          AUDamount: 25,
          GBPamount: 25,
          SGDamount: 25,
          AEDamount: 87.5,
          EURamount: 25
        }
      ], classLimit: 4
};
const referalDeductionDetails = (referralData: any, plan: any) => {
    let deductionAmount = 0;
    let mycash = 0;
    let fRedemtionAmount = 0;
    let total = +plan.discountedTotal;
    if (referralData.totalArtiumCash) {
        const artiumCashAmount = (+referralData.totalArtiumCash) * (+referralData[`${plan.currency}PointConversion`]);
        const redemtionRule = artiumCashReduction?.redemptionRules.find((item) => +plan.classCount >= item.count);
        if (redemtionRule) {
            fRedemtionAmount = +artiumCashAmount >= (redemtionRule as any)[`${plan.currency}amount`] ? +(redemtionRule as any)[`${plan.currency}amount`] : (+artiumCashAmount || 0);
            deductionAmount += (+fRedemtionAmount);
            if (+deductionAmount >= total) {
                deductionAmount = total;
                total = 0;
            }
        }
    }
    if (referralData.myCash) {
        mycash = (+referralData.myCash) * (+referralData[`${plan.currency}PointConversion`]);
        mycash = +mycash >= +total ? +total : mycash;
        deductionAmount += +mycash;
    }
    return {
        walletAmount: deductionAmount,
        artiumCash: fRedemtionAmount || 0,
        myCash: mycash || 0,
        artiumCashPoint: +referralData?.totalArtiumCash || 0,
        myCashPoint: +referralData?.myCash || 0,
    };
}

const createExternalCustomPlan = (courseList:any, referralData:any) => {
    let plan = ({} as any);
    plan.classCount = 0;
    plan.total = 0;
    plan.plan = "Custom Plan";
    plan.specialDiscountPercentage = 0;
    plan.additionalDiscountPercentage = 0;
    plan.flashDiscountPercentage = 0;
    plan.discountPercentage = 0;
    plan.discountedTotal = Math.max(+(plan.total - (plan.total * ((plan.discountPercentage + plan.specialDiscountPercentage + plan.additionalDiscountPercentage) / 100))).toFixed(2), 0);
    plan.discountedTotalwithFlash = Math.max(+(plan.total - (plan.total * ((plan.discountPercentage + plan.specialDiscountPercentage + plan.additionalDiscountPercentage + plan.flashDiscountPercentage) / 100))).toFixed(2), 0);
    plan.levelList = courseList.map((course:any) => {
        return {
            levelId: course.levelId,
            classCount: 0,
            unit_price: course.unit_price,
            level: course.level}
    });
    plan.courseId = courseList[0].courseId;
    //plan.sessionCounts = {[courseData.courseId.toString()]:plan.classCount};
    plan.currency = courseList[0].currency;
    let refData = referalDeductionDetails(referralData, plan);
    plan = {...plan, ...refData};
    if( +refData.walletAmount >= +plan.discountedTotal){
      plan.walletAmount = +plan.discountedTotal;
      plan.walletLabel = plan.walletAmount ? `${courseList[0].currency == 'INR'? '₹':'US$'}${(+plan.walletAmount.toFixed(2)).toLocaleString()} wallet balance applicable`: "";
    }else{
      plan.walletAmount = +refData.walletAmount;
      plan.walletLabel = refData.walletAmount ? `${courseList[0].currency == 'INR'? '₹':'US$'}${(+refData.walletAmount.toFixed(2)).toLocaleString()} wallet balance applicable`: "";
    }
    return plan;
}

const createCustomPlan = (courseList:any, referralData:any) => {
    let plan = ({} as any);
    plan.classCount = +courseList.reduce((acc:any, course:any) => acc + +course.totalClassesInCourse, 0);
    plan.total = Math.max(+courseList.reduce((acc:any, course:any) => acc + +(course.totalClassesInCourse * course.unit_price).toFixed(2), 0), 0);
    //plan.offerInfo= "Click Buy now for additional offers",
    plan.plan = "Custom Plan";
    plan.discountPercentage = 0;
    plan.additionalDiscountPercentage = 0;
    plan.flashDiscountPercentage = 0;
      const discountTiers = [
        { classes: 12, discount: 0 },
        { classes: 24, discount: 5 },
        { classes: 36, discount: 5 },
        { classes: 48, discount: 8 },
        { classes: 60, discount: 8 },
        { classes: 72, discount: 10 }
        // { classes: 96, discount: 15 }
    ];
    let specialDiscountPercentage = 0;
    for (let i = discountTiers.length - 1; i >= 0; i--) {
        if (plan.classCount >= discountTiers[i].classes) {
            specialDiscountPercentage = discountTiers[i].discount;
            break;
        }
    }
    plan.specialDiscountPercentage = specialDiscountPercentage;
    plan.discountedTotal = Math.max(+(plan.total - (plan.total * ((plan.discountPercentage + plan.specialDiscountPercentage) / 100))).toFixed(2), 0);
    //plan.discountedTotalwithFlash = Math.max(+(plan.total - (plan.total * ((plan.discountPercentage + plan.specialDiscountPercentage + plan.additionalDiscountPercentage + plan.flashDiscountPercentage) / 100))).toFixed(2), 0);
    plan.levelList = courseList.map((course:any) => {
        return {
            levelId: course.levelId,
            classCount: +course.totalClassesInCourse,
            unit_price: course.unit_price,
            level: course.level}
    });
    plan.packageInfo = `Includes ${plan.levelList.map((item: any) => item.classCount + ' ' + item.level).join(" and ")} classes`;  //"This package will cover only " + courseData.courseName + " course",
    plan.courseId = courseList[0].courseId;
    //plan.sessionCounts = {[courseData.courseId.toString()]:plan.classCount};
    plan.currency = courseList[0].currency;
    let refData = referalDeductionDetails(referralData, plan);
    plan = {...plan, ...refData};
    if( +refData.walletAmount >= +plan.discountedTotal){
      plan.walletAmount = +plan.discountedTotal;
      plan.walletLabel = plan.walletAmount ? `${courseList[0].currency == 'INR'? '₹':'US$'}${(+plan.walletAmount.toFixed(2)).toLocaleString()} wallet balance applicable`: "";
    }else{
      plan.walletAmount = +refData.walletAmount;
      plan.walletLabel = refData.walletAmount ? `${courseList[0].currency == 'INR'? '₹':'US$'}${(+refData.walletAmount.toFixed(2)).toLocaleString()} wallet balance applicable`: "";
    }
    return plan;
}

const calculetePackage = (packagedata:any, referralData:any) => {
     let clonePackage = JSON.parse(JSON.stringify(packagedata));
     let plan = clonePackage.customPlan;
     let levelList = plan.levelList;
     
     plan.classCount = levelList.reduce((acc:any, level:any) => acc + +level.classCount, 0);
     plan.total = Math.max(+levelList.reduce((acc:any, level:any) => acc + +(level.classCount * level.unit_price).toFixed(2), 0), 0);
     plan.discountedTotal = Math.max(+(plan.total - (plan.total * ((+plan.discountPercentage + +plan.specialDiscountPercentage) / 100))).toFixed(2), 0);
     //plan.discountedTotalwithFlash = Math.max(+(plan.total - (plan.total * ((+plan.discountPercentage + +plan.specialDiscountPercentage + +plan.additionalDiscountPercentage + +plan.flashDiscountPercentage) / 100))).toFixed(2), 0);
     if(packagedata.removeWallet || packagedata.isFree){
        plan.walletAmount = 0;
        plan.walletLabel = "";
        plan.myCash = 0;
        plan.artiumCash = 0;
     }else{
        let refData = referalDeductionDetails(referralData, plan);
        plan = {...plan, ...refData};
        if( +refData.walletAmount >= +plan.discountedTotal){
        plan.walletAmount = +plan.discountedTotal;
        plan.walletLabel = plan.walletAmount ? `${plan.currency == 'INR'? '₹':'US$'}${(+plan.walletAmount.toFixed(2)).toLocaleString()} wallet balance applicable`: "";
        }else{
        plan.walletAmount = +refData.walletAmount;
        plan.walletLabel = refData.walletAmount ? `${plan.currency == 'INR'? '₹':'US$'}${(+refData.walletAmount.toFixed(2)).toLocaleString()} wallet balance applicable`: "";
        }
     }
     if(packagedata.isFree){
        plan.total = 0;
        plan.discountedTotal = 0;
        plan.discountedTotalwithFlash = 0;
     }
     clonePackage.customPlan = plan;
     return clonePackage;
}

const createExternalPaymentRequest = (profileData:any, packageData:any) => {
    let totalPrice = 0;
    let courseList = packageData.customPlan.levelList
    .map((item: any) => {
        let course = packageData.courseData.find((course: any) => course.levelId === item.levelId);
        if (course && item.classCount > 0) {
            course.classesToPurchase = +item.classCount;
            course.discountPercentage = +packageData.customPlan.discountPercentage || 0;
            course.discountedPrice = +((item.classCount * course.unit_price) * (course.discountPercentage / 100)).toFixed(2);
            course.price = +((item.classCount * course.unit_price) - course.discountedPrice).toFixed(2);
            course.teacherId = packageData.selectedTeacher;
            totalPrice += course.price;
            course.isFree = packageData.isFree;
            return course; // Return modified course
        }
        return null; 
    }).filter((course:any) => course !== null);
    let dt = new Date();
      let d = dt.getDate();
      let m = dt.getMonth() + 1;
      let y = dt.getFullYear();

      let requesBody = {
        "studentId": profileData.studentId,
        "userId": profileData.userId,
        "totalPrice": +totalPrice.toFixed(2),
        "name": profileData.firstName + (profileData.lastName ? ' ' + profileData.lastName : ''),
        "contact": profileData.mobileNumber || '',
        "email": profileData.emailId || '',
        "countryCode": profileData.countryCode || '',
        "currency": packageData.currency,
        "customer_id": profileData.zohoSubscriptionCustomerId || "",
        "place_of_supply": "",
        "token": localStorage.getItem('authToken') || '',
        "artiumCashPoint": +packageData.customPlan.totalArtiumCash || 0,
        "myCashPoint": +packageData.customPlan.myCash || 0,
        "artiumCash": packageData.customPlan.artiumCash || 0,
        "myCash": packageData.customPlan.myCash || 0,
        "conversionRate": packageData.referralData ? +packageData.referralData[`${packageData.currency}PointConversion`] : 0,
        "referralCode": packageData.referralData?.referralCode || "",
        "version": "2.0",
        "academicVersion": "2.0",
        "paymentFor": "nonrazorpay",
        "platform": "web",
        //"isNonConversionTransaction" : this.state.skipConvertion,
        "createdBy": localStorage.loginUser || "",
        "gender":profileData.gender,
        "skipInvoice" : packageData.skipInvoice,
        "paymentMode" : packageData.paymentMode,
        "refNumber": packageData.refNumber,
        "ageGroup": profileData.ageGroup,
        "studentType": profileData.studentType,
        "userType": profileData.userType,
        "state": profileData.state,
        "isFree": packageData.isFree,
        "freeClassReason" : packageData.freeClassReason || "",
        "courseList": courseList,
        "timeZone": profileData.timezone || "",
        "invoice_date": (y + '-' + (m.toString().length < 2 ? '0' + m : m) + '-' + (d.toString().length < 2 ? '0' + d : d)),
        "expiryDate": packageData.expiryDate
      }
      return requesBody;
}

export {
    referalDeductionDetails,
    createCustomPlan,
    createExternalCustomPlan,
    calculetePackage,
    createExternalPaymentRequest
}